// extracted by mini-css-extract-plugin
export default {"ordinalInput":"_30sIrXpJ1nM6dRZLzwyAzy"};